import type { FC } from "react";
import {
  Box,
  DialogActions,
  List,
  ListItem,
  Stack,
  Typography,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { Translate, useTranslation } from "@privacy/translations";
import type { UnansweredMandatoryQuestionsError } from "../../../api/registrations.types";

export const UnansweredMandatoryQuestionsDialog: FC<{
  onClose: () => void;
  sections: UnansweredMandatoryQuestionsError["unansweredMandatoryQuestionSections"];
}> = ({ onClose, sections }) => {
  const { t } = useTranslation();
  const isMultipleUnansweredQuestions =
    sections.length > 1 || (sections[0] && sections[0].unansweredMandatoryQuestions.length > 1);

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>{t("RegistrationDrawer.UnansweredMandatoryQuestionsDialog.Header")}</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: theme => theme.typography.pxToRem(14), mb: 2 }}>
          <Translate
            translationKey="RegistrationDrawer.UnansweredMandatoryQuestionsDialog.Message"
            values={{
              questionSingularPlural: t(
                isMultipleUnansweredQuestions
                  ? "RegistrationDrawer.UnansweredMandatoryQuestionsDialog.QuestionPlural"
                  : "RegistrationDrawer.UnansweredMandatoryQuestionsDialog.QuestionSingular"
              ),
            }}
          />
        </Typography>

        <Stack sx={{ gap: 1 }}>
          {sections.map(({ sectionName, unansweredMandatoryQuestions }) => (
            <Box key={sectionName}>
              <Typography
                sx={{ fontSize: theme => theme.typography.pxToRem(14), fontWeight: 600, textDecoration: "none" }}
              >
                {sectionName}
              </Typography>
              <List sx={{ py: 0 }}>
                {unansweredMandatoryQuestions.map(({ header }) => (
                  <ListItem key={header} sx={{ py: 0 }}>
                    <Typography variant="body2">{header}</Typography>
                  </ListItem>
                ))}
              </List>
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("RegistrationDrawer.UnansweredMandatoryQuestionsDialog.Button")}</Button>
      </DialogActions>
    </Dialog>
  );
};
